import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";

export const TwoFactorStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      border: "1px solid #E5E9EB",
      borderRadius: "20px",
      padding: "20px 25px",
      marginBottom: "30px",
    },
    heading: {
      fontWeight: 600,
      fontSize: "18px",
      lineHeight: "30px",
    },
    link: {
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightBold,
      color: "#FFF",
      textTransformColor: "#FFF",
    },
    switch: {
      textAlign: "end",
      "& .MuiSwitch-switchBase.Mui-checked": {
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        },
      },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
    title: {
      fontSize: "20px",
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      width: "100%",
      borderBottom: "1px solid #EAEAEA",
      paddingBottom: "10px",
      [theme.breakpoints.down("md")]: {
        marginBottom: "20px",
      },
    },
    placeHolder: {
      fontSize: "14px",
      color: "#545454",
      fontWeight: theme.typography.fontWeightRegular,
    },
    content: {
      fontSize: "20px",
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightRegular,
      [theme.breakpoints.down("md")]: {
        marginBottom: "20px",
      },
    },
  }),
);
